import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';

@Component({
    selector: 'day-picker',
    template: ` 
        <div fxLayout="column">
            <span class="mat-select-placeholder mat-floating-placeholder" style="width: 99px; color: rgba(0, 0, 0, 0.38);">{{placeholder || 'Selected Days'}}</span>
            <div>
                <mat-button-toggle-group multiple="true" [disabled]="disabled" [value]="byDays" (change)="setDays($event)">
                    <mat-button-toggle value="SU">S</mat-button-toggle>
                    <mat-button-toggle value="MO">M</mat-button-toggle>
                    <mat-button-toggle value="TU">T</mat-button-toggle>
                    <mat-button-toggle value="WE">W</mat-button-toggle>
                    <mat-button-toggle value="TH">T</mat-button-toggle>
                    <mat-button-toggle value="FR">F</mat-button-toggle>
                    <mat-button-toggle value="SA">S</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>
    `,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DayPickerComponent),
        multi: true
    }]
})
export class DayPickerComponent implements ControlValueAccessor {
    @Input() placeholder;
    private propagateChange = (_: any) => { };
    private propagateTouched = () => { };
    disabled: boolean;
    byDays: string[];

    writeValue(obj: any): void {
        this.byDays = obj;
    }    
    
    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }
    
    registerOnTouched(fn: any): void {
        this.propagateTouched = fn;
    }
    
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    setDays(change: MatButtonToggleChange) {
        this.propagateChange(change.value);
        this.propagateTouched();
    }
}